import React from "react";
import { Link, ResponsiveImage } from "@quintype/components";
import { SvgIconHandler } from "../../../atoms/svg-icon-hadler";
import { UserFallbackIcon } from "../Svg/user-fallback-icon";
import "./author-box.m.css";

const authorImage = (author) => {
  const { "avatar-url": avatarUrl, "avatar-s3-key": avatarS3Key, name: authorName } = author;
  if (!avatarUrl && !avatarS3Key) {
    return <UserFallbackIcon />;
  }
  return (
    <figure>
      {avatarS3Key ? (
        <ResponsiveImage
          slug={avatarS3Key}
          aspectRatio={[1, 1]}
          defaultWidth={480}
          widths={[250, 480, 640]}
          imgParams={{ auto: ["format", "compress"] }}
          alt={authorName}
        />
      ) : (
        avatarUrl && <img src={avatarUrl} />
      )}
    </figure>
  );
};

export default function AuthorBox({ story }) {
  const mainAuthor = story.authors[0];
  const iconTypes = Object.keys(mainAuthor?.social).map((key) => ({ id: key, social: mainAuthor?.social[key] }));
  const slug = `/author/${mainAuthor.slug}`;
  const icon = { width: "44px", height: "44px", viewBox: "0 0 44 44" };
  return (
    <div className="author-box" styleName="author-box">
      <div styleName="author-card">
        <div styleName="author-info">
          <div styleName="author-image">
            <Link href={slug}>{authorImage(mainAuthor)}</Link>
          </div>
          <div styleName="author-name-designation">
            <Link href={slug}>{mainAuthor?.name}</Link>
            <span>{mainAuthor?.metadata?.designation}</span>
          </div>
        </div>
        {iconTypes?.length ? (
          <div styleName="author-socials">
            {iconTypes?.map((item, index) => {
              return (
                <Link key={index} href={item?.social?.url} target="_blank">
                  <SvgIconHandler
                    type={item.id === "twitter" ? `x` : `${item.id}`}
                    iconStyle={{ color: "#596E79" }}
                    height={icon.height}
                    width={icon.width}
                    viewBox={icon.viewBox}
                  />
                </Link>
              );
            })}
          </div>
        ) : (
          ""
        )}
      </div>
      {mainAuthor?.bio?.length && (
        <>
          <div styleName="author-bio">{mainAuthor?.bio}</div>
          <div styleName="more-bio">
            <Link href={slug}>Show More</Link>
          </div>
        </>
      )}
    </div>
  );
}
